import * as yup from "yup";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IoSaveOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";
import Textbox from "./../../../../../components/common/Textbox";
import Toaster from "./../../../../../components/common/Toaster";
import accountService from "./../../../../../services/accountService";

const schema = yup.object({
  id: yup.string(),
  ss_number: yup.string().nullable(),
  hdmf_number: yup.string().nullable(),
  philhealth_number: yup.string().nullable(),
  s2_license_number: yup.string().nullable(),
});

const GovernmentForm = ({ data, isLoading, setLoading, onSuccess }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  useEffect(() => {
    const populateForm = () => {
      setValue("id", data.id);
      setValue("ss_number", data.ss_number);
      setValue("hdmf_number", data.hdmf_number);
      setValue("philhealth_number", data.philhealth_number);
      setValue("s2_license_number", data.s2_license_number);
    };

    if (data) populateForm();
  }, [data, setValue]);

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await accountService.saveAccountCompliancesInfoAsync(data);
      Toaster.Success("Information Saved Successfully");
      onSuccess();
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-2">
        <div className="col-span-2">
          <Textbox
            id="ss-number-textbox"
            name="ss_number"
            type="text"
            title="SS No."
            register={register("ss_number")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-2">
        <div className="col-span-2">
          <Textbox
            id="hdmf-number-textbox"
            name="hdmf_number"
            type="text"
            title="HDMF No."
            register={register("hdmf_number")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-2">
        <div className="col-span-2">
          <Textbox
            id="philhealth-number-textbox"
            name="philhealth_number"
            type="text"
            title="Philhealth No."
            register={register("philhealth_number")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-2">
        <div className="col-span-2">
          <Textbox
            id="s2-license-number-textbox"
            name="s2_license_number"
            type="text"
            title="S2 License No."
            register={register("s2_license_number")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default GovernmentForm;
